export const iconFontAwesomeSecurityHandcuffs = (
	<i className="fa-solid fa-handcuffs"></i>
);
